import React from 'react';
import Hero from './Hero';
import ContactForm from './ContactForm'; // Import the ContactForm component
import './PizzaToEvents.css'; // Import a CSS file for styles

const PizzaToEvents = () => {
  return (
    <div className="pizza-to-events-container">
      <Hero text="שף פיצה לאירועים בכל הגדלים" />
      <div className="description">
      <p><strong>פיצה בהתאמה אישית, לכל אירוע</strong>
      -אנחנו מאמינים שכל אירוע הוא ייחודי, בדיוק כמו כל פיצה. בין אם אתם חוגגים יום הולדת אינטימי או מסיבה גדולה,  נשמח להתאים את התפריט לטעמים האישיים שלכם וליצור עבורכם חוויה קולינרית מותאמת אישית
      </p>
      <p><strong>טאבון פחמים, טעם אותנטי</strong>
      -הפיצות שלנו נאפות בטאבון פחמים מסורתי, מה שמעניק להן טעם עשיר ועשוי. כל ביס הוא חגיגה לחיך, טעם שמחזיר אתכם לשורשיו של מאכל קסום
      </p>
      <p><strong>מוצרלה איכותית, טעם בלתי נשכח</strong>
      -רק גבינת מוצרלה איכותית מגיעה אל הפיצות שלנו.כל נגיסה היא תערובת מושלמת של גבינה מותכת, רכה וטעימה, שלא תפסיקו לחשוב עליה
      </p>
      <p><strong>תוספות טריות, שילובים מנצחים</strong>
      -בחרו מתוך מגוון רחב של תוספות טריות ואיכותיות, או תנו לשף שלנו להפתיע אתכם עם שילובים יצירתיים ומיוחדים שיגרמו לכל פיצה להיות יצירת אומנות
      </p>
      <p><strong>חומרי גלם מהטבע, טעם אמיתי</strong>
      -אנחנו משתמשים רק בחומרי גלם טריים ואיכותיים, שנבחרים בקפידה.כל פרט- מעלה בזיליקום ועד לעגבניות נבחר בדיוק עבור טעם מושלם
      </p>
      <p> <strong>תוספות מיוחדות, חוויה קולינרית</strong>
      -תנו לטעם להתפוצץ לכם בפה עם התוספות המיוחדות שלנו: ריבת בצל מתקתקה, ריבת עגבניות שרי עסיסיות, קונפי ארטישוק מעודן, שום קונפי ועוד– כל תוספת מוסיפה קסם לחוויית הפיצה
      </p>
      </div>

      {/* Call to Action Button */}
     

      {/* Include the Contact Form */}
      <ContactForm />
      <a href="tel:0526996037" className="call-button">
      !התקשרו לשמוע עוד פרטים
      </a>
    </div>
  );
};

export default PizzaToEvents;
